import { render, staticRenderFns } from "./regulatoryOverlay.vue?vue&type=template&id=834addd4&scoped=true&"
import script from "./regulatoryOverlay.vue?vue&type=script&lang=js&"
export * from "./regulatoryOverlay.vue?vue&type=script&lang=js&"
import style0 from "./regulatoryOverlay.vue?vue&type=style&index=0&id=834addd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834addd4",
  null
  
)

export default component.exports